export const fileMimeToFileType = (fileMime: string): string => {
	switch (fileMime) {
		case 'application/vnd.ms-excel':
		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
			return 'XLSX';
		case 'image/svg+xml':
			return 'SVG';
		case 'image/jpeg':
			return 'JPG';
		default:
			return fileMime.split('/')[1]?.toUpperCase() ?? fileMime;
	}
};
